import React from "react";
import styles from "./styles.module.scss";
import { useGroupsModel } from "./indexModel";
import TransferSuccessModal from "./_components/TransferSuccessModal";
import NoGroupsResult from "./_components/NoGroups";
import ButtonVariant from "app/components/Button/ButtonVariant";
import GroupsList from "./GroupsList";
import LayoutWrapper from "./LayoutWrapper";

const Groups = () => {
  const {
    groups,
    searchTerm,
    onSearchGroup,
    createGroupModalHandler,
    isOpenCreateGroupModal,
    canCreateGroup,
    pending,
    sentryRef,
  } = useGroupsModel();

  if (groups?.length === 0 && !pending && searchTerm?.length > 0) {
    return (
      <LayoutWrapper
        onSearchGroup={onSearchGroup}
        isOpenCreateGroupModal={isOpenCreateGroupModal}
        createGroupModalHandler={createGroupModalHandler}
      >
        <NoGroupsResult searchResult={groups} searchedText={searchTerm} />
        {canCreateGroup && (
          <div className={styles.btn_wrapper}>
            <ButtonVariant
              buttonStyles={styles.add_btn}
              buttonType="primary"
              title={"Add new Group"}
              icon={<i className="ico ico-add" />}
              onClickFunc={createGroupModalHandler}
            />
          </div>
        )}
      </LayoutWrapper>
    );
  }

  return (
    <LayoutWrapper
      onSearchGroup={onSearchGroup}
      isOpenCreateGroupModal={isOpenCreateGroupModal}
      createGroupModalHandler={createGroupModalHandler}
    >
      <GroupsList
        groupsData={groups}
        pending={pending}
        onClickCreateGroup={createGroupModalHandler}
        containerRef={sentryRef}
      />
      <TransferSuccessModal />
    </LayoutWrapper>
  );
};

export default Groups;
